if (!customElements.get('sticky-button')) {
  class StickyButton extends HTMLElement {
    constructor() {
      super();
      this.header = document.querySelector('sticky-header');
      this.actButton = document.querySelector('[data-act-button]');

      this.submitButton = this.querySelector('button[type="submit"]');
      this.quantityInput = this.querySelector('input[data-cart-quantity]');
      this.variantIdInput = this.querySelector('input[data-variant-id]');

      this.cartDrawer = document.querySelector('cart-drawer');


      // Breakpoint for desktop/mobile behavior
      this.desktopBreakpoint = 900;


      // Initialize component if required elements exist
      if (this.actButton) {
        this.init();
      }

      this.submitButton.addEventListener('click', (e) => {
        e.preventDefault();
        this.handleStickyButtonClick();
      });
    }

    // Handle sticky button click - delegate to selling-plans component
    handleStickyButtonClick() {
      // Find the selling-plans component
      const sellingPlansComponent = document.querySelector('selling-plans');

      if (!sellingPlansComponent) {
        console.error('Selling plans component not found');
        return;
      }

      // Show loading state
      this.showLoadingState(this.submitButton);

      // Use selling-plans component's addToCartWithSellingPlan method
      sellingPlansComponent.addToCartWithSellingPlan()
        .then(data => {
          console.log('Product added to cart via selling-plans:', data);

          // The selling-plans component handles cart UI updates, but we can also update here if needed
          if (data && data.sections) {
            this.updateCartDrawerWithSections(data.sections);
          }
        })
        .catch(error => {
          console.error('Error adding to cart via selling-plans:', error);
          alert('Error adding product to cart. Please try again.');
        })
        .finally(() => {
          // Hide loading state
          this.hideLoadingState(this.submitButton);
        });
    }

    // Shows the loading state on the button
    showLoadingState(button) {
      button.classList.add('loading');
      button.setAttribute('aria-disabled', 'true');
      button.querySelector('.loading__spinner').classList.remove('hidden');
    }

    // Hides the loading state on the button
    hideLoadingState(button) {
      button.classList.remove('loading');
      button.removeAttribute('aria-disabled');
      button.querySelector('.loading__spinner').classList.add('hidden');
    }

    // Update cart drawer with sections data returned from cart API
    updateCartDrawerWithSections(sections) {
      if (!this.cartDrawer) {
        console.error('Cart drawer not found');
        return;
      }

      try {
        // Update cart drawer if section data is available
        if (sections['cart-drawer']) {
          const html = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
          const updatedCartDrawer = html.querySelector('cart-drawer');

          if (updatedCartDrawer) {
            const currentDrawerInner = this.cartDrawer.querySelector('.drawer__inner');
            const newDrawerInner = updatedCartDrawer.querySelector('.drawer__inner');

            if (currentDrawerInner && newDrawerInner) {
              currentDrawerInner.innerHTML = newDrawerInner.innerHTML;
            }

            // Remove empty class if cart now has items
            this.cartDrawer.classList.remove('is-empty');
          }
        }

        // Update cart icon bubble if section data is available
        if (sections['cart-icon-bubble']) {
          const html = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
          const updatedCartIcon = html.querySelector('#cart-icon-bubble');
          const currentCartIcon = document.querySelector('#cart-icon-bubble');

          if (updatedCartIcon && currentCartIcon) {
            currentCartIcon.innerHTML = updatedCartIcon.innerHTML;
          }
        }

        // Open the cart drawer
        this.cartDrawer.open();

      } catch (error) {
        console.error('Error updating cart drawer with sections:', error);

        // Fallback to manual section rendering
        this.updateCartDrawer();
      }
    }

    // Update cart drawer using Section Rendering API and open it
    updateCartDrawer() {
      if (!this.cartDrawer) {
        console.error('Cart drawer not found');
        return;
      }

      // Fetch updated cart drawer content using Section Rendering API
      fetch(`${window.Shopify.routes.root}?section_id=cart-drawer`)
        .then(response => response.text())
        .then(responseText => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const updatedCartDrawer = html.querySelector('cart-drawer');

          if (updatedCartDrawer) {
            // Update the cart drawer content
            const currentDrawerInner = this.cartDrawer.querySelector('.drawer__inner');
            const newDrawerInner = updatedCartDrawer.querySelector('.drawer__inner');

            if (currentDrawerInner && newDrawerInner) {
              currentDrawerInner.innerHTML = newDrawerInner.innerHTML;
            }

            // Remove empty class if cart now has items
            this.cartDrawer.classList.remove('is-empty');

            // Update cart icon bubble as well
            this.updateCartIconBubble();

            // Open the cart drawer
            this.cartDrawer.open();
          }
        })
        .catch(error => {
          console.error('Error updating cart drawer:', error);

          // Fallback: still try to open the cart drawer even if update failed
          this.cartDrawer.open();
        });
    }

    // Update cart icon bubble to reflect new cart count
    updateCartIconBubble() {
      fetch(`${window.Shopify.routes.root}?section_id=cart-icon-bubble`)
        .then(response => response.text())
        .then(responseText => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const updatedCartIcon = html.querySelector('#cart-icon-bubble');
          const currentCartIcon = document.querySelector('#cart-icon-bubble');

          if (updatedCartIcon && currentCartIcon) {
            currentCartIcon.innerHTML = updatedCartIcon.innerHTML;
          }
        })
        .catch(error => {
          console.error('Error updating cart icon:', error);
        });
    }

    // Initialize the sticky button functionality
    init() {
      this.setupIntersectionObserver();
      this.setupEventListeners();
      this.updatePosition(); // Set initial position
    }

    // Set up intersection observer to show/hide button based on actButton visibility
    setupIntersectionObserver() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          this.toggleButtonVisibility(entry.isIntersecting);
        });
      }, {
        threshold: 0.5 // Trigger when 50% of the element is visible
      });

      observer.observe(this.actButton);
    }

    // Toggle button visibility based on actButton intersection and scroll position
    toggleButtonVisibility(isIntersecting) {
      if (isIntersecting) {
        // actButton is in view, hide sticky button
        this.removeAttribute('data-show');
      } else {
        // actButton is not in view, check if we're below it
        const actButtonRect = this.actButton.getBoundingClientRect();
        const scrollY = window.scrollY || window.pageYOffset;
        const actButtonTop = actButtonRect.top + scrollY;
        const currentScrollPosition = scrollY + window.innerHeight / 2;

        // Only show sticky button if we've scrolled past the ATC button
        if (currentScrollPosition > actButtonTop) {
          this.setAttribute('data-show', '');
        } else {
          this.removeAttribute('data-show');
        }
      }
    }

    // Set up event listeners for resize and scroll events
    setupEventListeners() {
      // Handle responsive positioning on window resize
      window.addEventListener('resize', () => {
        this.updatePosition();
      });

      // Update position on scroll for desktop
      window.addEventListener('scroll', () => {
        this.updatePosition();
      });
    }

    // Check if current viewport is desktop size
    isDesktop() {
      return window.innerWidth >= this.desktopBreakpoint;
    }

    // Update button position based on viewport size and header position
    updatePosition() {
      if (this.isDesktop()) {
        this.setDesktopPosition();
      } else {
        this.setMobilePosition();
      }
    }

    // Set position for desktop viewport (below header)
    setDesktopPosition() {
      if (!this.header) return;

      const headerRect = this.header.getBoundingClientRect();
      const headerBottom = headerRect.bottom;

      this.style.top = `${headerBottom}px`;
      this.style.bottom = 'unset';
    }

    // Set position for mobile viewport (bottom of screen)
    setMobilePosition() {
      this.style.top = 'unset';
      this.style.bottom = '0px';
    }

    // Update sticky button content when variant changes using Section Rendering API
    updateVariantInfo(variant) {
      if (!variant) return;

      // Get the current product URL and section ID from the sticky button
      const productUrl = this.dataset.productUrl || window.location.pathname;
      const sectionId = this.dataset.sectionId;

      if (!sectionId) {
        console.warn('Sticky button missing data-section-id attribute');
        return;
      }

      // Build request URL for Section Rendering API
      const requestUrl = `${productUrl}?variant=${variant.id}&section_id=${sectionId}`;

      // Fetch updated sticky button content
      fetch(requestUrl)
        .then(response => response.text())
        .then(responseText => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const updatedStickyButton = html.querySelector('sticky-button');

          if (updatedStickyButton) {
            // Replace the current sticky button content with the updated version
            this.innerHTML = updatedStickyButton.innerHTML;

            // Re-initialize position after content update
            this.updatePosition();
          }
        })
        .catch(error => {
          console.error('Error updating sticky button:', error);
        });
    }
  }

  customElements.define('sticky-button', StickyButton);
}